const dict = {
    chooseLang: "اختر اللغة",
    agree: "موافق",

    //Licence
    instructions: "التعليمات",
    step1: "الخطوة الأولى: امسح رمز QR",
    locateqr: "ابحث عن رمز QR على يمينك.",
    useSmartphone:
        "استخدم كاميرا هاتفك الذكي أو تطبيق مسح رمز QR لمسحه. سيأخذك هذا إلى الخطوة التالية.",
    step2: "الخطوة الثانية: أدخل معلومات قائمة التشغيل",
    afterScan: "بعد مسح رمز QR، ستُطلب منك إدخال معلومات قائمة التشغيل الخاصة بك.",
    makeSure: "تأكد من ملء جميع الحقول المطلوبة.",
    step3: "الخطوة الثالثة: العودة إلى التطبيق",
    onceYou:
        "بعد إدخال تفاصيل قائمة التشغيل، يمكنك العودة إلى التطبيق ومتابعة تجربتك.",
    refresh: "تحديث",
    playlist: "قائمة التشغيل",
    bigPlaylist: "قوائم التشغيل",
    noLicence: "ليس لديك ترخيص.",
    scanLicence: "امسح لشراء الترخيص.",
    noPlaylist: "ليس لديك أي قائمة تشغيل",
    privacyBig: "وضع الخصوصية",
    scanToAddBig: "امسح لإضافة قائمة تشغيل",
    scanToBuyBig: "امسح لشراء الترخيص",
    orVisit: "أو قم بزيارة",
    andenterdeviceID: "وأدخل معرّف الجهاز هذا:",
    removePlaylist: "إزالة قائمة التشغيل",
    wantToRemove: "هل تريد الإزالة؟",
    cancelBig: "إلغاء",
    loading: "جارٍ التحميل...",
    enablePMode: "يرجى تفعيل وضع الخصوصية لمتابعة المشاهدة.",
    killSwitchProtecting: "يحمي Kill Switch خصوصيتك عن طريق حظر الوصول عند إيقاف تشغيل وضع الخصوصية.",
    kSwitchProtecionActive: "حماية Kill Switch نشطة",
    privacyMode: "وضع الخصوصية",
    ok: "موافق",

    //Home
    bigLiveTv: "التلفزيون المباشر",
    bigMovies: "الأفلام",
    bigSeries: "المسلسلات",
    //Channel-Menu
    noChannels: "قائمة التشغيل هذه لا تحتوي على بيانات قنوات",
    searchChannels: "البحث عن قناة",
    tapToPlay: "اضغط لتشغيل بث الفيديو.",
    categoryEmpty: "هذه الفئة فارغة",
    pinNotSet: "لم يتم تعيين رمز PIN",
    setPinNow: " هل تريد تعيين رمز PIN الآن؟",
    preview: "معاينة",
    liveTv: "التلفزيون المباشر",
    addToFav: "إضافة إلى المفضلة",
    removeFromFav: "إزالة من المفضلة",
    now: "الآن:",
    nextPlaying: "التالي:",
    channels: "القنوات",
    noChannelsFound: "لم يتم العثور على قنوات",

    //Movies
    noMovies: "قائمة التشغيل هذه لا تحتوي على بيانات أفلام",
    searchMovies: "البحث عن أفلام",
    noFavMovies: "لا توجد أفلام مفضلة",
    //series
    noSeries: "قائمة التشغيل هذه لا تحتوي على بيانات مسلسلات",
    searchSeries: "البحث عن مسلسلات",
    noFavSeries: "لا توجد مسلسلات مفضلة",
    search: " بحث",
    thereIsProblem: "هناك مشكلة في الوقت الحالي",
    tryAgainLater: "يرجى المحاولة مرة أخرى لاحقًا.",
    series: "المسلسلات",
    movies: "الأفلام",
    noSeriesFound: "لم يتم العثور على مسلسلات",
    noMoviesFound: "لم يتم العثور على أفلام",
    //entity
    play: "تشغيل",
    playMovie: "تشغيل الفيلم",
    recommendations: "توصيات",
    //User Info
    userInfo: "معلومات المستخدم",
    aboutApp: "حول التطبيق",
    //Userinfo
    account: "الحساب",
    subscriptions: "الاشتراكات",
    privacyPilicy: "الخصوصية والسياسة",
    languge: "اللغة",
    english: "الإنجليزية",
    italian: "الإيطالية",
    german: "الألمانية",
    spanish: "الإسبانية",
    french: "الفرنسية",
    saudiArabia: "العربية",
    chinese: "الصينية",
    greek: "اليونانية",
    turkish: "التركية",
    change_pin: "تغيير الرقم السري",
    kill_switch: "مفتاح الإيقاف",
    device_info: "معلومات الجهاز",
    unknown: "غير معروف",

    //headers
    settings: "الإعدادات",
    termsConditions: "الشروط والأحكام",
    home: "الرئيسية",

    //license
    scanQrCode: "امسح رمز QR لإرسال قائمة تشغيل",
    managePlaylist: "إدارة قائمة التشغيل",
    orVisitt: "أو قم بزيارة",
    scanToAdd: "امسح لإضافة قائمة تشغيل أو قم بزيارة",

    //device info
    display: "الشاشة",
    storage: "التخزين",
    network: "الشبكة",
    connection: "الاتصال",
    macAddress: "عنوان MAC:",
    deviceId: "معرّف الجهاز:",
    pmInfo: "معلومات وضع الخصوصية",
    statusActive: "الحالة: نشط",
    underMaintance: "الحالة: تحت الصيانة",
    version: "الإصدار:",
    lastBuildDate: "تاريخ آخر إصدار:",
    lastUpdated: "آخر تحديث: ",

    //kill switch
    enableKillSwitch: "تفعيل Kill Switch؟",
    disableKillSwitch: "تعطيل Kill Switch؟",
    whenEnabled: "عند التفعيل، سيعمل OrbixPlay فقط عند تشغيل وضع الخصوصية.",
    withOrWithoutPM: "سيعمل OrbixPlay بشكل طبيعي مع أو بدون وضع الخصوصية.",
    extra_privacy_protection: " حماية خصوصية إضافية",
    pmOn: "• إذا كان وضع الخصوصية مفعّلًا: يمكنك بث المحتوى بأمان",
    killSwitchDescription: "يوفر Kill Switch طبقة حماية إضافية لضمان أقصى قدر من الخصوصية.",
    pmOff: "• إذا كان وضع الخصوصية معطّلًا: سيحظر التطبيق الوصول لحماية خصوصيتك",
    reenable: "يمكنك إعادة تفعيله في أي وقت للحصول على أقصى قدر من الأمان.",
    cancel: "إلغاء",
    enable: "تفعيل",
    disable: "تعطيل",
    killSwitch: "Kill Switch – حماية خصوصية إضافية",
    ipHidden: "عند تشغيل وضع الخصوصية، يتم إخفاء عنوان IP الخاص بك ويمر اتصالك عبر نظام آمن — على غرار طريقة عمل VPN.",
    extraLayer: "Kill Switch هو طبقة حماية إضافية: إذا قمت بتفعيله، فسيعمل OrbixPlay فقط عند تشغيل وضع الخصوصية.",
    ifPmOn: "• إذا كان وضع الخصوصية مفعّلًا: يمكنك بث المحتوى بأمان",
    ifPmOff: "• إذا كان وضع الخصوصية معطّلًا: سيحظر التطبيق الوصول لحماية خصوصيتك",
    recommended: "موصى به لأي شخص يريد أقصى قدر من الأمان ولا يريد البث أبدًا بدون حماية.",
    current_status: "الحالة الحالية:",
    pressToDisable: "🛡️ مفعّل - اضغط للتعطيل",
    pressToEnable: "○ معطّل - اضغط للتفعيل",
    pressEnter: " اضغط Enter على الزر أعلاه لتغيير إعداد Kill Switch",

    //set pin
    pinSetSuccessfully: "تم تعيين رمز PIN بنجاح!",
    createPin: "أنشئ رمز PIN الخاص بك",
    confirmPin: "أكّد رمز PIN الخاص بك",
    confirmYourPin: "confirmPin: 'أكّد رمز PIN الخاص بك'",
    initializingPin: "جارٍ تهيئة إعداد رمز PIN...",
    enterCurrentPin: "أدخل رمز PIN الحالي",
    enterNewPin: "أدخل رمز PIN الجديد",
    confirmNewPin: "أكّد رمز PIN الجديد",
    pinChanged: "تم تغيير رمز PIN بنجاح!",
    pinHasChanged: " تم تغيير رمز PIN الخاص بك بنجاح!",

    //lastones
    playInfo: "معلومات قائمة التشغيل",
    playName: "اسم قائمة التشغيل:",
    host: "المضيف:",
    username: "اسم المستخدم:",
    password: "كلمة المرور:",
    packName: "اسم الباقة:",
    expireDate: "تاريخ الانتهاء:",

    //privacyPolicy
    one: "1. إخلاء المسؤولية عن المحتوى: OrbixPlay هي منصة مصممة لتعزيز تجربتك الرقمية. ومع ذلك، من المهم ملاحظة أن OrbixPlay لا تستضيف أو توفر أو توزع محتوى الفيديو. خدمتنا منظمة لدعم رحلتك الرقمية، لكننا لا نتحمل المسؤولية عن توفر المواد المرئية أو جودتها أو محتواها، إذ يقع ذلك خارج نطاق خدماتنا.",
    two: "2. عدم المسؤولية عن محتوى الطرف الثالث: لا تتحمل OrbixPlay LLC المسؤولية عن أي محتوى تابع لطرف ثالث قد تصل إليه من خلال تطبيقنا. تقع مسؤولية تعاملك مع أي محتوى خارجي، بما في ذلك مشروعيته وموثوقيته وملاءمته، على عاتقك وحدك.",
    three:
        "3. الاختصاص القضائي والامتثال: تعمل OrbixPlay LLC تحت اختصاص قضائي الولايات المتحدة الأمريكية. يتحمل المستخدمون مسؤولية التأكد من أن استخدامهم للتطبيق يتوافق مع جميع القوانين المحلية والولائية والفيدرالية.",
    four: "4. سياسة التسعير: قد تتغير أسعار خدمات OrbixPlay في أي وقت دون إشعار مسبق. بقبول هذه الاتفاقية، تقرّ وتوافق على أن الأسعار قد تتفاوت وأن هذه التغييرات لن تؤثر على خدمتك الحالية حتى تجديد اشتراكك.",
    five: `5. لا ضمان: يتم توفير تطبيق OrbixPlay وخدماته "كما هي" دون أي ضمانات صريحة أو ضمنية، بما في ذلك على سبيل المثال لا الحصر، الضمانات الضمنية للتسويق والملاءمة لغرض معين وعدم الانتهاك.`,
    six: "6. قبول الشروط: بالنقر على موافق، فإنك توافق على الالتزام بشروط إخلاء المسؤولية هذه وتقرّ بأن أي انتهاك قد يؤدي إلى إنهاء وصولك إلى خدمات OrbixPlay.",
    orbixUserAgreement: "اتفاقية مستخدم OrbixPlay وإخلاء المسؤولية",
    beforeyouProcc: "قبل المتابعة، يرجى قراءة الشروط والأحكام التالية والموافقة عليها:",

    //additional
    exitApp: "الخروج من OrbixPlay",
    wantToExit: "هل أنت متأكد أنك تريد الخروج من OrbixPlay؟",
    Resume: "استئناف",

    whatsnewinv: "ما الجديد في الإصدار v",
    whatsnew: "ما الجديد",

    resellerInfiniteDevices: "خطة الموزع: أجهزة غير محدودة",
    resellerInfiniteDevicesDesc: "يمكن الآن تثبيت نفس القائمة على عدد غير محدود من الأجهزة — ليس 5 أو 10، بل بقدر ما تحتاج.",
    thankyouforusingorbixplayenjoythenewfeatures: "شكرًا لاستخدامك OrbixPlay — استمتع بالميزات الجديدة!",

    instanthomescreen: "متابعة المشاهدة",
    instanthomescreendesc: "استأنف مسلسلاتك وأفلامك من حيث توقفت.",
    turbomoviesearch: "ميزة المفضلة",
    turbomoviesearchdesc: "احفظ المحتوى المفضل لديك للوصول السريع والسهل في أي وقت.",
    lighterondataandbattery: "استقرار محسّن للمشغّل",
    lighterondataandbatterydesc: "موثوقية تشغيل محسّنة وعمليات بحث أكثر سلاسة.",
    underthehoodfixes: "إصلاحات داخلية",
    underthehoodfixesdesc: "إصلاحات متعددة للأخطاء وتحسينات في الأداء لتجربة أفضل.",

    proxyMaintenance: 'صيانة الخادم الوكيل',
    proxyMaintenanceMessage: 'الخادم الوكيل تحت الصيانة حاليًا. يرجى المحاولة مرة أخرى لاحقًا.',

    playlistInformation: 'معلومات قائمة التشغيل',
    playlistExpDate: 'تاريخ انتهاء قائمة التشغيل: ',

    select_playlist: "اختر قائمة التشغيل",
    choose_playlist: "اختر قائمة تشغيل لبدء المشاهدة",
    invalid_line: "سطر غير صالح",
    expire_date: "تاريخ الانتهاء:",
    expired: "منتهي الصلاحية",
    waiting_connection: "في انتظار الاتصال...",
    reconnection_attempt: "محاولة إعادة الاتصال",
    try_again: "حاول مرة أخرى",
    go_back: "رجوع",
    unable_to_resume: "تعذّر الاستئناف",
    reconnecting: "جارٍ إعادة الاتصال...",
    no_internet_connection: "لا يوجد اتصال بالإنترنت",
    please_try_again: "تعذّر إعادة تشغيل البث. يرجى المحاولة مرة أخرى.",
    restore_stream: "يرجى الانتظار بينما نستعيد بثّك.",
    reconnect_automatically: "تحقق من شبكتك وسنعيد الاتصال تلقائيًا.",
    check_wifi: "تحقق من اتصال WiFi الخاص بك",
    check_ethernet: "تحقق من اتصال Ethernet / LAN الخاص بك",
    check_internet: "تحقق من اتصالك بالإنترنت",

    add_playlist_screen: "إضافة قائمة تشغيل",
    add_playlist: "إضافة قائمة تشغيل يدوياً",
    playlist_name_required: "اسم قائمة التشغيل مطلوب",
    m3u_url_required: "رابط M3U لقائمة التشغيل مطلوب",
    server_url_required: "رابط الخادم مطلوب",
    username_required: "اسم المستخدم مطلوب",
    password_required: "كلمة المرور مطلوبة",
    orbix_code_required: "رمز مضيف Orbix مطلوب",
    list_code_required: "رمز القائمة مطلوب",
    device_id_required: "معرّف الجهاز مطلوب",
    device_id: "معرّف الجهاز : ",
    playlist_format: "تنسيق قائمة التشغيل",
    m3u: "رابط M3U",
    username_password: "اسم المستخدم / كلمة المرور",
    orbix_code: "رمز Orbix",
    list_code: "رمز القائمة",
    playListName: "اسم قائمة التشغيل *",
    m3uUrl: "رابط قائمة M3U *",
    server_URL: "رابط الخادم *",
    username_req: "اسم المستخدم *",
    password_req: "كلمة المرور *",
    orbix_code_req: "رمز مضيف Orbix *",
    list_code_req: "رمز القائمة *",
    addPlaylist: "إضافة قائمة تشغيل",
    adding: "جارٍ الإضافة...",
    my_playlist: "قائمة التشغيل الخاصة بي",
    username_placeholder: "اسم المستخدم",
    password_placeholder: "••••••••",

    //stream exceptions
    stream_extension: "امتداد البث",

    //storage_and_data
    storage_and_data: "التخزين والبيانات",

    // ── Parental PIN ──────────────────────────────────────────────────────────
    enter_parental_pin: "أدخل رقم PIN الأبوي",

    // ── Account / Subscriptions labels ───────────────────────────────────────
    status: "الحالة",
    active: "نشط",
    expiration: "انتهاء الصلاحية",
    max_connections: "الحد الأقصى للاتصالات",
    one_device: "جهاز واحد",
    created: "تاريخ الإنشاء",

    // ── Storage & Data screen ─────────────────────────────────────────────────
    section_title: "التخزين والبيانات",
    section_subtitle: "إدارة بيانات التطبيق المحفوظة",
    favourites_label: "المفضلة",
    history_label: "سجل المشاهدة",
    cleared_label: "تم المسح",
    all_cleared_label: "تم مسح الكل",
    remove_cancel_label: "إلغاء",
    remove_confirm_label: "مسح",
    clear_fav_channels_title: "القنوات المفضلة",
    clear_fav_channels_subtitle: "إزالة جميع القنوات المحفوظة",
    clear_fav_channels_message: "مسح جميع القنوات المفضلة؟",
    clear_fav_movies_title: "الأفلام المفضلة",
    clear_fav_movies_subtitle: "إزالة جميع الأفلام المحفوظة",
    clear_fav_movies_message: "مسح جميع الأفلام المفضلة؟",
    clear_fav_series_title: "المسلسلات المفضلة",
    clear_fav_series_subtitle: "إزالة جميع المسلسلات المحفوظة",
    clear_fav_series_message: "مسح جميع المسلسلات المفضلة؟",
    clear_continue_watching_movies_title: "متابعة المشاهدة – أفلام",
    clear_continue_watching_movies_subtitle: "إزالة تقدم مشاهدة الأفلام",
    clear_continue_watching_series_title: "متابعة المشاهدة – مسلسلات",
    clear_continue_watching_series_subtitle: "إزالة تقدم مشاهدة المسلسلات",
    clear_continue_watching_title: "متابعة المشاهدة",
    clear_continue_watching_message: "مسح سجل المشاهدة؟",
    clear_all_title: "مسح جميع البيانات",
    clear_all_message: "سيؤدي هذا إلى مسح جميع المفضلة وسجل المشاهدة.",

    // ── Stream Extension screen ───────────────────────────────────────────────
    stream_extension_desc: "اختر كيفية طلب البث المباشر من خادمك.",
    ts_desc: "بث MPEG-TS القياسي",
    m3u8_desc: "بث HLS التكيفي",
    current: "الحالي",

    // ── Kill Switch modal ─────────────────────────────────────────────────────
    access_restricted: "🛡️ الوصول مقيّد",
    to_access_playlists: "للوصول إلى قوائم التشغيل:",
    enable_privacy_mode_step: "1. فعّل وضع الخصوصية من الشاشة الرئيسية",
    disable_kill_switch_step: "2. أو عطّل Kill Switch في الإعدادات ← Kill Switch",
    preparingContent: "جارٍ تحضير المحتوى",

    // ── Home screen ──────────────────────────────────────────────────────────────
    loading_base: "جارٍ التحميل",
    live_now: "بث مباشر",
    news: "أخبار",
    sport: "رياضة",
    kids: "أطفال",

    // ── Series details ───────────────────────────────────────────────────────────
    episode: "الحلقة",
    no_episodes: "لا توجد حلقات متاحة لهذا الموسم.",

    // ── Search keyboard ───────────────────────────────────────────────────────
    searchForChannels: "البحث عن القنوات...",
    kbSpace: "مسافة",
    kbCaps: "كبير",
    pressOkToPlay: "اضغط OK للتشغيل",
    live: "مباشر",
};

export default dict;